// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2889":"c1f069e6","3969":"315b5e8b"}[chunkId] + ".chunk.css";
};